import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "reactstrap";

import { DotPulse } from "@uiball/loaders";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { LoadMoreCourses } from "../../store/actions/HolesAction";

function CoursesTable({ courseData }) {
    console.log("courseData: ", courseData);
    const history = useHistory();
    const dispatch = useDispatch();
    const { quickSearch, courseLoader } = useSelector((state) => state.course);
    const [courseCount, setCoursesCount] = useState(courseData?.length);

    useEffect(() => {
        setCoursesCount(courseData?.length);
    }, [quickSearch]);

    return (
        <>
            {/* {loader ? (
                <div className="vh-100 d-flex justify-content-center align-items-center">
                    <Spinner> </Spinner>
                </div>
            ) : (
                <> */}
            <Row className="px-md-0 mx-0 px-0 mt-5" style={{ overflowX: 'scroll' }}>

                    <table className="table table-hover mb-0 fs--14">
                        <thead>
                            <tr>
                                {/* <th scope="col">#</th> */}
                                <th scope="col" style={{ minWidth:200 }}>Course Name</th>
                                <th scope="col">City</th>
                                <th scope="col">State / Province / Region</th>
                                <th scope="col">Country</th>
                                <th scope="col">Maps</th>
                            </tr>
                        </thead>
                        <tbody>
                            {courseData && courseData.length > 0 ? (
                                courseData?.map((item, id) => (
                                    <tr key={id}>
                                        {/* <td
                                            scope="row"
                                            className="align-middle fs--14"
                                        >
                                            {id + 1}
                                        </td> */}
                                        <td className="align-middle text-site-primary link-hover fs--15 fw--600">
                                            <div>
                                                <a
                                                    // href="#"
                                                    onClick={() => {
                                                        item?.isMapAvailable &&
                                                            history.push({
                                                                pathname: `/courses/holes/${item.id}`,
                                                                state: {
                                                                    course: item,
                                                                },
                                                            });
                                                    }}
                                                    className={` custom-a-hover ${
                                                        item?.isMapAvailable
                                                            ? "cursor-pointer"
                                                            : ""
                                                    }`}
                                                >
                                                    {item.name}
                                                </a>
                                            </div>
                                            <div className="text-muted fs--12">
                                                {item?.address?.street}
                                            </div>
                                        </td>
                                        <td className="fs--14 text-muted align-middle cursor-pointer custom-a-hover">
                                            {item?.address?.city}
                                        </td>
                                        <td className="fs--14 text-muted align-middle cursor-pointer custom-a-hover">
                                            {item?.address?.state}
                                        </td>
                                        <td className="fs--14 text-muted align-middle">
                                            {item?.address?.country}
                                        </td>
                                        <td className="fs--14 align-middle text-site-primary">
                                            {item?.isMapAvailable ? (
                                                <a
                                                    className="cursor-pointer custom-a-hover"
                                                    onClick={() => {
                                                        history.push({
                                                            pathname: `/courses/holes/${item.id}`,
                                                            state: {
                                                                course: item,
                                                            },
                                                        });
                                                    }}
                                                >
                                                    Available
                                                </a>
                                            ) : (
                                                <h6 className="text-muted fs--14">
                                                    Not Available
                                                </h6>
                                            )}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td></td>
                                    <td>No Course Found</td>
                                    <td></td>
                                </tr>
                            )}
                        </tbody>
                    </table>

            </Row>{" "}
            <div className="text-center">
                {courseCount != 0 && !(courseCount < 25) && (
                    <Button
                        disabled={courseLoader}
                        size="md"
                        className="bg-light text-site-muted shadow-sm border-0 my-2"
                        onClick={(event) => {
                            dispatch(
                                LoadMoreCourses(
                                    {
                                        ...quickSearch,
                                        marker: courseData[
                                            courseData.length - 1
                                        ]?.id,
                                    },
                                    (count) => {
                                        setCoursesCount(count);
                                    }
                                )
                            );
                        }}
                    >
                        {courseLoader ? (
                            <DotPulse size={25} speed={1.3} color="white" />
                        ) : (
                            "Load More"
                        )}
                    </Button>
                )}
            </div>
            {/* </>
            )} */}
        </>
    );
}

export default CoursesTable;
